class ConceptSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const modalSwiper = new Swiper("." + this.el, {
      loop: true,
      speed: 1000,
      spaceBetween: 200,
  
      // Navigation arrows
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },

    });

    const modalBtn = ('.js-concept-modal-btn');
    const modalTarget = ('.js-concept-modal');
    const modalClose = ('.js-concept-modal-close');

    $(modalBtn).on('click',function(){
      let modalNum = $(this).attr('data-modal');
      modalNum++;
      $(modalTarget).fadeIn(500).css('display','flex');
      modalSwiper.update();
      modalSwiper.slideTo(modalNum,0);
    })

    $(modalClose).on('click',function(){
      $(modalTarget).fadeOut(500);
    })
  }
}
